import { gql } from '@apollo/client'
import { Col, ColNumber, Container, Row } from '@farol-ds/react'
import classNames from 'classnames'

import { PlanFrequency } from '../../../../../constants'
import { PaywallCarousel } from '../../../../paywall-carousel'
import { useChooseOfferFrequencyLaterContext } from '../../../context-provider'
import { ChooseFrequencyLaterLinksFooter } from '../../choose-frequency-later-links-footer'
import { ChooseFrequencyLaterOfferCard } from '../../choose-frequency-later-offer-card'
import { ChooseFrequencyLaterOfferCard_OfferLockCardFragment } from '../../choose-frequency-later-offer-card/__generated__/choose-frequency-later-offer-card.graphql'
import { ChooseFrequencyLaterSelectOfferStep_OfferLockDataFragment } from './__generated__/choose-frequency-later-select-offer-step.graphql'
import styles from './choose-frequency-later-select-offer-step.module.scss'

interface ChooseFrequencyLaterSelectOfferStepProps {
  offerLockData: ChooseFrequencyLaterSelectOfferStep_OfferLockDataFragment
}

export const ChooseFrequencyLaterSelectOfferStep = ({
  offerLockData,
}: ChooseFrequencyLaterSelectOfferStepProps) => {
  const { isPaywall, hasYearlyOffers, compactHeader, handleSelectPlan } =
    useChooseOfferFrequencyLaterContext()

  const { footer } = offerLockData || {}

  const initialCardOffers = offerLockData?.body?.cards
    ?.filter((card) => {
      const frequencyToFilter = hasYearlyOffers ? PlanFrequency.YEARLY : PlanFrequency.MONTHLY
      return card.offer.frequency === frequencyToFilter
    })
    .filter((card, index, self) => index === self.findIndex((c) => c.title === card.title))

  const renderOfferCard = (
    card: ChooseFrequencyLaterOfferCard_OfferLockCardFragment,
    index: number
  ) => {
    return (
      <ChooseFrequencyLaterOfferCard
        key={`offer-card-${index}`}
        offerLockCard={card}
        compact={compactHeader}
        onBtnClick={handleSelectPlan}
      />
    )
  }

  return (
    <>
      {isPaywall && initialCardOffers.length > 2 ? (
        <main>
          <Container>
            <PaywallCarousel
              cards={initialCardOffers}
              renderCard={renderOfferCard}
              mobileClassName={styles.mobilePaywallOffersContent}
              carouselItemClassName={styles.carouselItem}
            />
          </Container>
        </main>
      ) : (
        <Row
          className={classNames(styles.offerCardsRow, {
            [styles.singleOffer]: initialCardOffers.length < 2,
            [styles.offerCardsRowPaywall]: isPaywall,
          })}
        >
          {initialCardOffers.map((card, index) => (
            <Col
              key={`${card.title}-${index}`}
              xs={12}
              md={(12 / initialCardOffers.length) as ColNumber}
              className={styles.offerCard}
            >
              {renderOfferCard(card, index)}
            </Col>
          ))}
        </Row>
      )}

      {footer && !!footer?.links?.length && <ChooseFrequencyLaterLinksFooter footer={footer} />}
    </>
  )
}

ChooseFrequencyLaterSelectOfferStep.fragments = {
  offerLockData: gql`
    fragment ChooseFrequencyLaterSelectOfferStep_offerLockData on OfferLockData {
      body {
        cards {
          ...ChooseFrequencyLaterOfferCard_offerLockCard
        }
      }
      footer {
        ...ChooseFrequencyLaterLinksFooter_offerLockFooter
      }
    }
    ${ChooseFrequencyLaterOfferCard.fragments.offerLockCard}
    ${ChooseFrequencyLaterLinksFooter.fragments.offerLockFooter}
  `,
}
